//条码规则校验放在winform端执行，暂时未迁移到Vue
import exp from "constants";
import dayjs from "dayjs";
import { LogHelper } from "@/common/LogHelper";
import { store_commonModule } from "@/store/modules/store_common";

export const checkCodesAndType = (codes: any, opcode: any = null, containNo: any = null) =>
  obj_HttpRequest_Core.checkCodesAndType(codes, opcode, containNo);

export const toolsRegularCheckCode = (data: any) =>
  obj_HttpRequest_Core.toolsRegularCheckCode(data);


//自定义过滤拦截条码规则查询(需要写入文件)
export const customRuleSearch = (LocalMac: string, CompName: string, CurrentDeviceType: string, InOutFlag: string) =>
  obj_HttpRequest_Core.customRuleSearch(LocalMac, CompName, CurrentDeviceType, InOutFlag);

//以下是http请求

//【特殊】url作为参数
export const dynamicUrlPost = (url: string, data: any, timeout: any, tokenSignatureFlag: any) =>
  obj_HttpRequest_Core.post(url, data, timeout, tokenSignatureFlag);

//正常http请求
export const getOrgCodeListByPage = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/orgCodeList", data);

export const getAutoCreatedCarCode = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/getContainerLabel", data);

export const getLineListByPage = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/lineList", data);

export const checkioTypes = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/ioTypes", data);

export const getWeightForPackage = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/getWeight", data);

export const getCqNoByCpNo = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/queryCqNo", data);

export const getCQInfoByCode = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/getCQInfoByCode", data);

export const querySwitch = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/querySwitch", data);

export const checklineFrequencys = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/lineFrequencys", data);

export const checkCode = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/inputNo", data);

//新的通缉件校验接口
export const newCheckWanted = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/automation/validate", data);

//异常上传
export const abnormalMovingPartDataUpload = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/uploadAbnormalOpRecord", data);

//精简版上车协议
export const abord = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/cv/truckLoading", data);

export const truckOperation = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/generic", data);

export const weightHistory = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/loadometer/weightHistory", data);


export const weight = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/loadometer/weight", data);


export const getLineInfoByCarcode = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/getLineInfoByCQ", data);

//发车界面 根据车签查询下一网点
export const faCheGetNextOrgCodeByCQ = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/faCheGetNextOrgCodeByCQ", data);

//查询时效类型：72小时、36小时等
export const queryTimeTypes = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/timeTypes", data);

//查询揽收界面频率种类
export const queryOpFrequency = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/opFrequency", data);

//查询揽收寄件客户
export const queryCustomerInfo = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/customerInfo", data);

//查询三段码
export const modeNew = (data: any) => {
  let startTime = dayjs().valueOf();
  let resJson = obj_HttpRequest_Core.post("/Yto_BusiGateway/client/automation/modeNew", data);
  let endTime = dayjs().valueOf();
  LogHelper.WriteLog(
    "modenew的请求时间为:" +
    (endTime - startTime) +
    dayjs().format("YYYY-MM-DD HH:mm:ss SSS")
  );
  let res = JSON.parse(resJson);
  try {
    if (res.data && res.data.in_OUT_FLAG && (res.data.in_OUT_FLAG == "1" || res.data.in_OUT_FLAG == "2")) {
      if (!store_commonModule.orderInfoList) {
        store_commonModule.SetOrderInfoList([])
      }
      console.log(res.data.waybill_NO);
      var item = store_commonModule.orderInfoList.find((fx) => {
        return fx.code == res.data.waybill_NO;
      });
      if (item) {
        item.inOutFlag = res.data.in_OUT_FLAG
      } else {
        store_commonModule.orderInfoList.push({
          code: res.data.waybill_NO,
          inOutFlag: res.data.in_OUT_FLAG,
        })
      }
    }
  } catch (e) {
    console.error(e)
  }
  res.startTime = startTime;
  res.endTime = startTime;

  return res;
}

//揽收删除
export const collectOnly = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/collectOnly", data);

//揽发合一
export const takingTruckUpload = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/takingTruckUpload", data);

//车签使用状态查询接口
export const carContainerStatus = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/queryCarContainerStatus", data);

export const cloudPress = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/cloud/process/1", data);

export const cloudPressForSortingGataWay = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/cloud/process/1", data, 30000, true, true);

export const clientOptLog = function (waybillnos:string[], body:string[],logType:string) {
  // const data = {
  //   body,waybillnos,logType
  // }
  // obj_HttpRequest_Core.post("/Yto_BusiGateway/client/test/record",JSON.stringify(data));
}

//基础数据查询
export const lookUpBaseData = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/table", data);

//基础数据下载接口
export const uploadBaseData = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/baseDataList", data);

//大号段数据查询
export const bigNumberCheck = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/materialCompress", data);

//单计泡
export const bubblePackage = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/danjipao", data);

//地磅称重
export const uploadTareWeight = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/loadometer/uploadTareWeight", data);

//地磅称重
export const uploadWeight = (data: any) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/loadometer/uploadWeight", data);


export const searchWeightHistory = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/loadometer/weightHistory", data);

export const getCarInfoByCode = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/getCarInfoByCode", data);

//当前设备是否可放开长宽高锁定接口
export const queryLockWeight = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/queryLockWeight", data);

//回流扫描操作量上传
export const backFLowOperationCountUpload = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_Monitor/Adapter/newOperationTotal", data);

//下车自动生成车签功能
export const get171Container = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/automation/get171Container", data);

//根据车签返回应卸件数
export const unLoadNum = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/unLoadNum", data);

//debusOnly
export const debusOnly = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/performance/debusOnly", data);

//现在用来下车页面查询进出港，暂未有其他用法
export const getLatticeScheme = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/automation/getLatticeScheme", data);

//新下车接口
export const truckUnloading = (data: string) => {
  let res = obj_HttpRequest_Core.post("/Yto_BusiGateway/cv/truckUnloading", data);
  return res;
}

//操作量上传
export const newOperationTotal = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_Monitor/Adapter/newOperationTotal", data);


//上车校验该车签号是否已经做了封车和发车操作
export const queryFrontInfo = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/automation/queryFrontInfo", data);

//通用查询接口
export const query = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/query", data);

//维修发放
export const repairSupply = (data: string) =>
  obj_HttpRequest_Core.webClientSendData("/hbd/provideAction", data);

//维修报废
export const repairSortingScarp = (data: string) =>
  obj_HttpRequest_Core.webClientSendData("/hbd/repaireFactoryController/repairSortingScrap", data);

//维修工厂查询
export const repaitFactorySearch = (data: string) =>
  obj_HttpRequest_Core.webClientSendData("/hbd/repaireFactoryController/repairFactoryList", data);

//交叉带设备名称查询
export const  queryAllDevices=(data: string) =>
  obj_HttpRequest_Core.post("/Yto_BusiGateway/client/query/queryJCDLatticeScheme",data);

//OSD信息下载接口
export const osdInfoDownLoad = (data: string) =>
  obj_HttpRequest_Core.post("/Yto_MonitorGateway/baseDataOperate/opOsdCamera", data);

export const queryNewBagRulesCount = () =>
  obj_HttpRequest_Core.post("/Yto_MonitorGateway/client/query/countBagRulesV1", JSON.stringify({ body: {} }));
